import React, { useEffect, useState } from "react";
import { Container, ListGroup, Button, Alert, Spinner, Row } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

const ConsultantsTab = ({ user }) => {
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applyingId, setApplyingId] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/private/api/consultants`)
      .then(res => res.json())
      .then(data => setConsultants(data))
      .catch(() => setErrorMsg("Failed to fetch consultants."))
      .finally(() => setLoading(false));
  }, []);

  const handleApplyConsultant = async (consultant) => {
    if (!user || user.role !== "B2B") {
      setErrorMsg("Please log in as B2B user to apply for a consultant.");
      return;
    }
    setApplyingId(consultant._id);
    setSuccessMsg("");
    setErrorMsg("");
    try {
      const res = await fetch(`${API_URL}/private/api/apply-consultant`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          b2bId: user._id,
          consultantId: consultant._id
        })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccessMsg(`Successfully applied for ${consultant.name}.`);
      } else {
        setErrorMsg(data.message || "Failed to apply.");
      }
    } catch (err) {
      setErrorMsg("Something went wrong. Try again.");
    }
    setApplyingId(null);
  };

  return (
    <Container className="py-4">
      <h3 className="mb-4">All Consultants</h3>
      {successMsg && <Alert variant="success" onClose={() => setSuccessMsg("")} dismissible>{successMsg}</Alert>}
      {errorMsg && <Alert variant="danger" onClose={() => setErrorMsg("")} dismissible>{errorMsg}</Alert>}

      {loading ? (
        <div className="text-center py-5"><Spinner animation="border" /></div>
      ) : (
        <Row>
          <ListGroup>
            {consultants.length === 0 && (
              <ListGroup.Item className="text-center">No consultants found.</ListGroup.Item>
            )}
            {consultants.map((c) => (
              <ListGroup.Item key={c._id} className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  {/* <div><b>Name:</b> {c.name}</div> */}
                  {c.position && <div><b>Position:</b> {c.position}</div>}
                  <div><b>Skills:</b> {Array.isArray(c.skills) ? c.skills.join(", ") : c.skills || "—"}</div>
                  {c.availability && <div><b>Availability:</b> {c.availability}</div>}
                  {c.rate && <div><b>Rate:</b> {c.rate}</div>}
                </div>
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    disabled={applyingId === c._id}
                    onClick={() => handleApplyConsultant(c)}
                  >
                    {applyingId === c._id ? "Applying..." : "Apply"}
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Row>
      )}
    </Container>
  );
};

export default ConsultantsTab;
